import Redirect from 'tripPlanner/components/Redirect'
import useChatTripPlannerReleaseState from 'tripPlanner/hooks/useChatTripPlannerReleaseState'
import { CHAT_TRIP_PLANNER_ROUTE } from 'tripPlanner/pages/chat/ChatTripPlannerPage/hooks/useChatNavigation'
import TripPlannerLandingPage from './TripPlannerLandingPage'

function TripPlannerLandingRoute() {
  const {
    hasChatTripPlannerDirectEntryDecisionError,
    isLoadingChatTripPlannerDirectEntryDecision,
    shouldUseChatTripPlannerDirectEntryPoint,
  } = useChatTripPlannerReleaseState()

  if (
    isLoadingChatTripPlannerDirectEntryDecision &&
    !hasChatTripPlannerDirectEntryDecisionError
  ) {
    return null
  }

  if (shouldUseChatTripPlannerDirectEntryPoint) {
    return <Redirect to={CHAT_TRIP_PLANNER_ROUTE} />
  }

  return <TripPlannerLandingPage />
}

export default TripPlannerLandingRoute
